import { useCallback, useState } from "preact/hooks";

export function usePatchState<T>(
    defaultValue: T,
): readonly [T, (patch: Partial<T>) => void] {
    const [state, setState] = useState(defaultValue);

    const patchState = useCallback((patch: Partial<T>) => {
        setState((state) => ({ ...state, ...patch }));
    }, []);

    return [state, patchState];
}
